import { Box, Card, CardContent, FormControlLabel, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const HeaderTitle = styled(Typography)(({ color }) => ({
  color,
  margin: 0,
  fontWeight: 600,
}));

export const FormSectionContainer = styled(Box)({
  width: '100%',
});

export const FormSectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.25),
  width: '100%',
}));

export const FormControlContainer = styled(FormControlLabel)({
  minWidth: '100px',
  flexShrink: 0,
  margin: 0,
});

export const ChartPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: 'white',
  border: '1px solid #0000001a',
  marginBottom: theme.spacing(2),
}));

export const ChartContainer = styled(Box)({
  width: '100%',
  minHeight: '400px',
});

export const SelectorContainer = styled('section')({
  width: '100%',
});

export const SelectorTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledDashboardCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
}));

export const DashboardCardContent = styled(CardContent)({
  padding: '16px',
});
